package org.ksdfv.thelema.kxjs.data

import org.khronos.webgl.ArrayBufferView
import org.khronos.webgl.Uint16Array
import org.khronos.webgl.get
import org.khronos.webgl.set
import org.ksdfv.thelema.data.IShortData

/** @author zeganstyl */
class JsUInt16Array(val shortArray: Uint16Array): IShortData, JsArrayBufferView<Short>() {
    override val array: ArrayBufferView
        get() = shortArray

    override var size: Int = shortArray.length

    override val capacity: Int
        get() = shortArray.length

    override fun set(index: Int, value: Short) {
        shortArray[index] = value
    }

    override fun get(index: Int): Short = shortArray[index]

    override fun get(): Short {
        val value = shortArray[position]
        position++
        return value
    }

    override fun put(value: Short) {
        shortArray[position] = value
        position++
    }
}